import { RouteObject } from "react-router-dom";
import React from "react";
import ProtectedRoute from "components/auth/ProtectedRoute";
// import DataCoreFlowChart from "pages/DataCoreFlowChart";
import Home from "pages/Home";
// import Login from "pages/Login/Login";
// import SimEngineFlowChart from "pages/SimEngineFlowChart";
import Callback from "components/auth/ProtectedRoute/Callback";
import NsoSteps from "pages/DataCoreFlowChart/NsoSteps";
import SimEngineFlowChartSteps from "pages/SimEngineFlowChart/SimEngineFlowChartSteps";

export const routes: RouteObject[] = [
  {
    id: "callback",
    path: "/callback",
    element: <Callback />,
  },
  {
    id: "home",
    path: "/",
    element: (
      <ProtectedRoute>
        <Home />
      </ProtectedRoute>
    ),
  },
  {
    id: "datacoreflow",
    path: "/dataCoreFlow/:id",
    element: (
      <ProtectedRoute>
        <NsoSteps />
      </ProtectedRoute>
    ),
  },
  {
    id: "simengineflow",
    path: "/simEngineFlow/:id",
    element: (
      <ProtectedRoute>
        <SimEngineFlowChartSteps />
      </ProtectedRoute>
    ),
  },
  {
    id: "errorPage",
    path: "*",
    element: (
      <ProtectedRoute>
        <div>404</div>
      </ProtectedRoute>
    ),
  },
];
